import RecentSearch from "./RecentSearch";
export default RecentSearch;